import * as Yup from 'yup'
const ipRegex = /^((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){3}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})$/;

export const PACNAME = {
  label: "Pacname",
  validation: {
    required: "PACS name is required",
  },
};

export const AETITLE = {
  label: "AETITLE",
  validation: {
    required: "AE Title is required",
  },
}

export const LOCALPACSADDRESS = {
  label: "Local Pacs Address",
  validation: {
    required: "Local Pacs Address is required",
  },
  regex: /^(http:\/\/|https:\/\/)([a-zA-Z0-9.-]+)(:\d+)?$/,
}

export const MODALITY = {
  label: "Modality",
  validation: {
    required: "Modality is required",
  },
}

export const STUDY_REGION = {
  label: "Study Region",
  validation: {
    required: "Study Region is required",
  },
}

export const PRICE = {
  label: "Price",
  validation: {
    required: "Price is required",
  },
}

export const PacsFormSchema = Yup.object().shape({
  aeTitle: Yup.string().required(AETITLE.validation.required),
  localPacsAddress: Yup.string()
  .required(LOCALPACSADDRESS.validation.required),
  kcClientId: Yup.string().required('Keyclock Client ID is required'),
  kcClientSecret: Yup.string().required('Keyclock Client Secret is required'),
  kcURL: Yup.string().required('Keyclock URL is required'),
})

export const PricingFormSchema = Yup.object().shape({
  modality: Yup.array().required(MODALITY.validation.required),
  studyRegion: Yup.array()
  .required(STUDY_REGION.validation.required),
  price: Yup.string()
  .required(PRICE.validation.required)
})
